import { render } from "./KanbanOrcamento.vue?vue&type=template&id=5eb96ed6&scoped=true"
import script from "./KanbanOrcamento.vue?vue&type=script&lang=ts"
export * from "./KanbanOrcamento.vue?vue&type=script&lang=ts"

import "./KanbanOrcamento.vue?vue&type=style&index=0&id=5eb96ed6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5eb96ed6"

export default script